export default function Card({
  children,
  className = "",
  padded = true,
  as: Component = "div",
}) {
  const padding = padded ? "p-5" : "";
  return (
    <Component
      className={`rounded-(--radius-lg) bg-(--surface-1) ${padding} ${className}`.trim()}
    >
      {children}
    </Component>
  );
}
